export default __webpack_public_path__ + "static/media/ico_document.a5bd3e8d.svg";